import Headroom from 'headroom.js/dist/headroom.js'
import anime from 'animejs/lib/anime.es.js'

/**
 * Handle dropdowns for header items
 */
$(function() {
    var NavState = {
        Closed: 1,
        Open: 2,
    };
    var SubNavState = {
        Closed: 1,
        Open: 2,
        Move: 3,
    };

    var context = {
        $root: $('.js-MainNav'),
        $open_button: $('<button class="MainNavToggle">Menu</button>'),
        state: NavState.Closed,
        layout: {
            $main: $('.js-HeaderLayout  .js-HeaderLayout-main'),
            $logo: $('.js-HeaderLayout  .js-HeaderLayout-logo'),
        },
        subnav: {
            $root: $('.js-SubNavs'),
            state: SubNavState.Closed,
            active_element: null,
        }
    }

    if (context.$root.length == 0 || context.subnav.$root.length == 0) {
        // @NOTE(Grey): We can't do much if we don't have either of our elements
        return;
    }

   function subnav_hide() {
        $(window).off('click', subnav_hide);

        context.$root.find('.MainNav-list-item-link.is-open')
            .removeClass('is-open');

        anime({
            targets: context.subnav.$root.get(0),
            translateY: [0, -24],
            opacity: [1, 0],
            easing: "cubicBezier(0.335, 0, 0.335, 1)",
            duration: 250,
            complete: function() {
                context.subnav.$root.removeClass('is-visible');
                context.subnav.$root.removeAttr('style');

                context.layout.$main.removeClass('is-showing-subnav');

                $(context.subnav.active_element).addClass('is-hidden');
                context.subnav.active_element = null;

                context.subnav.state = SubNavState.Closed;
            }
        });
    }


    function subnav_position(layout_ctx, subnav_ctx, $anchor, $subnav_to_show) {
            // @NOTE(Grey): Clear the previous sizing so we don't get the wrong measurements
            var prev_subnav_element_bbox = subnav_ctx.$root.css(['left', 'top', 'width', 'height']);
            subnav_ctx.$root.removeAttr('style');

            // @NOTE(Grey): We need to measure the subnav, so we unhide it
            var was_invisible = false;
            if (subnav_ctx.$root.hasClass('is-visible') == false) {
                was_invisible = true;
                subnav_ctx.$root.addClass('is-visible');
            }

            var target_bbox = $anchor.get(0).getBoundingClientRect();
            var subnav_bbox = $subnav_to_show.get(0).getBoundingClientRect();
            var subnav_box_element = subnav_ctx.$root.get(0);

            if (was_invisible) {
                subnav_ctx.$root.removeClass('is-visible');
            }

            var curr_subnav_element_bbox = {
                left: ((target_bbox.x + (target_bbox.width / 2)) - (subnav_bbox.width / 2)) + 'px',
                top: target_bbox.bottom + 16 + 'px',
                width: subnav_bbox.width + 'px',
                height: subnav_bbox.height + 'px'
            };

            if (window.innerWidth < 540) {
                curr_subnav_element_bbox.left = 0 + 'px';
                curr_subnav_element_bbox.top = 0 + 'px';
            }

            subnav_box_element.style.left   = curr_subnav_element_bbox.left;
            subnav_box_element.style.top    = curr_subnav_element_bbox.top;
            subnav_box_element.style.width  = curr_subnav_element_bbox.width;
            subnav_box_element.style.height = curr_subnav_element_bbox.height;

            if (context.subnav.state == SubNavState.Move) {
                // @NOTE(Grey): Animate the subnav in from the right
                anime({
                    targets: $subnav_to_show.get(0),
                    translateX: [50, 0],
                    opacity: [0, 1],
                    easing: "cubicBezier(0.335, 0, 0.335, 1)",
                    delay: 100,
                    duration: 250,
                })

                // @NOTE(Grey): Animate subnav background
                anime({
                    targets: context.subnav.$root.get(0),
                    left:   [prev_subnav_element_bbox.left,   curr_subnav_element_bbox.left  ],
                    top:    [prev_subnav_element_bbox.top,    curr_subnav_element_bbox.top   ],
                    width:  [prev_subnav_element_bbox.width,  curr_subnav_element_bbox.width ],
                    height: [prev_subnav_element_bbox.height, curr_subnav_element_bbox.height],
                    easing: "cubicBezier(0.335, 0, 0.335, 1)",
                    duration: 250,
                    complete: function(anim) {
                        context.subnav.state = SubNavState.Open
                    },
                });
            }
    }


    context.layout.$logo.append(context.$open_button);
    context.subnav.$root.find('.js-SubNav').addClass('is-hidden');
    if (window.innerWidth >= 1075) {
        context.state = NavState.Open;
        context.layout.$main.addClass('is-open');
    }

    // @NOTE(Grey): Headroom initialization
    {
        var el = document.querySelector('.js-StickyBar');
        if (el !== null) {
            var hr_instance = new Headroom(el, {
                "offset": 67,
                onUnpin: function() { subnav_hide(); }
            });
            hr_instance.init();
        }
    }

    $(window).on('keyup', function(event) {
        if (event.key == "Escape") {
            subnav_hide();
        }
    });

    // @NOTE(Grey): This is to prevent the subnav from closing when it is clicked
    context.subnav.$root.on('click', function(event) {
        event.stopPropagation();
    });


    // @NOTE(Grey): Handles the narrow screen toggle button for the main nav
    context.$open_button.on('click', function(event) {
        if (context.state == NavState.Closed) {
            context.state = NavState.Open;

            context.layout.$main.addClass('is-open');
            var bbox = context.layout.$main.get(0).getBoundingClientRect();

            anime({
                targets: context.layout.$main.get(0),
                translateY: [-24, 0],
                opacity: [0, 1],
                easing: "cubicBezier(0.335, 0, 0.335, 1)",
                duration: 250,
                complete: function() {
                    context.layout.$main.removeAttr('style');
                }
            });

        } else if (context.state == NavState.Open) {
            context.state = NavState.Closed;

            var bbox = context.layout.$main.get(0).getBoundingClientRect();
            anime({
                targets: context.layout.$main.get(0),
                translateY: [0, -24],
                opacity: [1, 0],
                easing: "cubicBezier(0.335, 0, 0, 1)",
                duration: 250,
                complete: function() {
                    context.layout.$main.removeClass('is-open');
                    context.layout.$main.removeAttr('style');
                }
            });
        }
    });

    $(window).on('resize', function(event) {
        // @NOTE(Grey): Position the subnav as the window resizes
        if (context.subnav.active_element) {
            var $target = context.$root.find('.MainNav-list-item-link.is-open');
            var $subnav = $(context.subnav.active_element);

            subnav_position(context.layout, context.subnav, $target, $subnav);
        }
    });

    context.$root.on('click', '.js-MainNav-list-item--has-dropdown', function(event) {
        var $target = $(event.target);
        var $subnav = null;

        if ($target.data() && $target.data()['subnav']) {
            $subnav = $('#subnav-' + $target.data()['subnav']);

            if ($subnav.length < 1) {
                return;
            }
        }

        // @NOTE(Grey): We have a subnav and can now do work on it
        event.stopPropagation();
        event.preventDefault();

        // @NOTE(Grey): close the subnav if the one we are asking for
        // is the one that is currently open
        if (context.subnav.$root.hasClass('is-visible') &&
            $subnav.get(0) == context.subnav.active_element) {
            subnav_hide();
            $target.removeClass('is-open');
            return;

        } else {
            var $subnav_prev = null;

            if (context.subnav.active_element) {
                $subnav_prev = $(context.subnav.active_element);

                $subnav_prev.addClass('is-hidden');
                context.$root.find('.MainNav-list-item-link.is-open')
                    .removeClass('is-open');

                context.subnav.state = SubNavState.Move;
            }

            context.subnav.active_element = $subnav.get(0);
            $subnav.removeClass('is-hidden');

            subnav_position(context.layout, context.subnav, $target, $subnav);

            context.subnav.$root.addClass('is-visible');
            context.layout.$main.addClass('is-showing-subnav');

            if (context.subnav.state == SubNavState.Closed) {
                context.subnav.state = SubNavState.Open;
                anime({
                    targets: context.subnav.$root.get(0),
                    translateY: [-24, 0],
                    opacity: [0, 1],
                    easing: "cubicBezier(0.335, 0, 0.335, 1)",
                    duration: 250,
                });
            }

            $target.addClass('is-open');

            if ($subnav_prev) {
                $subnav_prev.addClass('is-hidden');
            }

            $(window).on('click', subnav_hide);
        }
    });
});



/**
 * Handle GA tag events
 */
$(function() {
    function fireGaEvent(label) {
        // This will grab the appropriate tracker from GTM (can change without warning),
        // and fire events against it
        var trackerName = ga.getAll()[0].get('name');
        ga(trackerName + '.send', {
            hitType: 'event',
            eventCategory: 'Header',
            eventAction: 'click',
            eventLabel: label
        });
    }

    $('.js-mainnav .js-GAEvent').on('mousedown', function () {
        var title = $(this).data('gatitle') || $(this).text();
        fireGaEvent(title);
    });
})